import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Api from '../api/api';
import StringHelpers from '../../utilities/stringHelpers';
import Enum from '../../utilities/enum';
import { SearchSelect } from '../shared/searchSelect';
export default function ConditionDialog(props) {

    const [letterTemplateConditionTypes, setLetterTemplateConditionTypes] = useState(null);
    const [condition, setCondition] = useState(props.condition ? props.condition.letterTemplateConditionType : null);
    const [showArgument, setShowArgument] = useState(false);
    const [argument, setArgument] = useState(props.condition ? props.condition.argument : null);
    const [argumentText, setArgumentText] = useState("");
    
    const getAllConditions = function () {
        Api.getEnums(
            (data) => { setLetterTemplateConditionTypes(data.letterTemplateConditionType); },
            (error) => console.log(error),
            props.token
        )
    };

    const cancel = function() {
        if (props.onCancel) {
            props.onCancel();
        }
    };

    const save = function() {
        if (props.onSave) {
            props.onSave(condition, argument);
        }
    };

    useEffect(() => {
        getAllConditions();
    }, []);

    useEffect(() => {
        setShowArgument(false);
        
        if (letterTemplateConditionTypes !== null) {
            let letterTemplateConditionType = letterTemplateConditionTypes[condition];
            if (!StringHelpers.isNullOrEmpty(letterTemplateConditionType) && letterTemplateConditionType.indexOf("{{0}}") > -1) {
                setShowArgument(true);
                setArgumentText(letterTemplateConditionType.replace("{{0}}", (StringHelpers.isNullOrEmpty(argument) ? "n" : (Number(condition) === 0 || Number(condition) === 16 || Number(condition) === 17) ? Enum.BreachStatus[argument] : argument)));
            } else {
                setShowArgument(false);
                setArgument("");
                setArgumentText(letterTemplateConditionTypes[condition]);
            }
        };

    }, [condition, argument, letterTemplateConditionTypes]);

    return <Modal show size="lg">
    <Modal.Header>
      <Modal.Title>Edit Condition</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {letterTemplateConditionTypes !== null && Object.keys(letterTemplateConditionTypes).length > 0 &&
            <div className="row mb-3">
                <label class="col-sm-3 col-form-label col-form-label-sm">Condition</label>  
                <div className="col-sm-9">
                    <SearchSelect 
                        buttonText={condition !== null && argumentText}
                        options={Object.entries(letterTemplateConditionTypes).map(([key, value]) => ({value: key, label: value}))}
                        onSelect={value => setCondition(Number(value))}
                        selected={condition !== null ? String(condition) : null}
                        defaultLabel='Select Condition'
                    />
                </div>
            </div>
        }
        {showArgument &&
            <div className="row mb-3">
                <label class="col-sm-3 col-form-label col-form-label-sm">Argument</label>  
                <div className="col-sm-9">
                    {Number(condition) === 0 || Number(condition) === 16 || Number(condition) === 17 ?
                     <SearchSelect 
                        options={Object.entries(Enum.BreachStatus).map(([key, value]) => ({value: key, label: value}))}
                        onSelect={value => {setArgument(value)}}
                        selected={argument !== null ? String(argument) : null}
                        defaultLabel='Select Status'
                    />
                    :
                      <input className="form-control form-control-sm" type="text" value={argument} onChange={(e) => setArgument(e.target.value)} />
                    }
                </div>
            </div>
        }
    </Modal.Body>
    <Modal.Footer>
        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={cancel}>Cancel</button>
        <button type="button" className="btn btn-success btn-sm ml-2" data-dismiss="modal" onClick={save}>Save</button>
    </Modal.Footer>
  </Modal>
    
   
}